import http from "../helpers/http";
import { getExternalSystemParams } from "../utils/partner";
class FaqAPI {
  /**
   * Get all FAQs
   * @returns {Promise<Object>} Response containing FAQs data
   */
  async getFaqs({ token, id, phone }) {
    try {
      const response = await http.post("GetFaqs", {
        Token: token,
        ID: id,
        ...getExternalSystemParams(),
        Phone: phone,
      });
      return response;
    } catch (error) {
      console.error("Failed to get FAQs:", error);
      throw error;
    }
  }
}

const faqAPI = new FaqAPI();
export default faqAPI;
